/**
 * PRP-MCP-5 (G2): how a chat-created estimate is named and opened. PRP-FEEDBACK-2 (B-7516c):
 * which imports are in no project.
 *
 * PRP-WEB-1 W2.1: the card that listed these above the projects table is gone; the dashboard's
 * Estimates tab (EstimatesTable) lists every estimate, chat and imported, with "Add to project"
 * on the ones in no project. These helpers are what it and the project Overview share.
 *
 * Source: the user's stored imports (`GET /imports/`, already scoped to the
 * signed-in user server-side). A chat-created estimate's id starts with
 * `mcp-` (`app/mcp/estimates.py MCP_ID_PREFIX`); its stored filename reads
 * "Created in chat: <name>". No backend route was added for this.
 */
import type { ImportSummary } from '../../types';

/** Mirrors the backend's MCP_ID_PREFIX. */
export const CHAT_ESTIMATE_PREFIX = 'mcp-';
const NAME_PREFIX = 'Created in chat: ';

/** The display name of a chat estimate. */
export function chatEstimateName(row: ImportSummary): string {
  const f = (row.filename ?? '').trim();
  if (!f) return 'Chat estimate';
  return f.startsWith(NAME_PREFIX) ? f.slice(NAME_PREFIX.length).trim() || 'Chat estimate' : f;
}

/** The estimate page URL for a stored import. */
export function estimatePageUrl(row: ImportSummary): string {
  return (
    `/completeness?import=${encodeURIComponent(row.parse_hash)}` +
    (row.project_id ? `&project=${encodeURIComponent(row.project_id)}` : '')
  );
}

/** The display name of an import (B-7515: the server's `name`, else the filename). */
export function importName(row: ImportSummary): string {
  return (row.name ?? '').trim() || (row.filename ?? '').trim() || row.parse_hash.slice(0, 12);
}

/** Imports with no project that are not chat estimates (those always have one). */
export function unlinkedImports(all: ImportSummary[]): ImportSummary[] {
  return all.filter((r) => !r?.project_id && !(r?.parse_hash ?? '').startsWith(CHAT_ESTIMATE_PREFIX));
}
